// Import Swiper and modules
import SwiperCore, { Navigation, Pagination, Scrollbar, Swiper, Lazy } from 'swiper/core';

// Install modules
SwiperCore.use([Navigation, Pagination, Scrollbar, Lazy]);

const Home = {
    init: function() {
        if (window.md.phone()) {
            new Swiper('#focustrand', {
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '#focustrand-pagination',
                    type: 'bullets',
                },
            })
            new Swiper('#mosaic', {
                lazy: {
                    loadPrevNext: true,
                },
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '#mosaic-pagination',
                    type: 'bullets',
                },
            })
        }

        new Swiper('#product-slider', {
            lazy: {
                loadPrevNext: true,
            },
            slidesPerView: 5,
            spaceBetween: 20,
            navigation: {
                nextEl: '.prod-button-next',
                prevEl: '.prod-button-prev',
            },
            loop: true,
            breakpoints: {
                1440: {
                    slidesPerView: 5,
                    spaceBetween: 20
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                375: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0
                }
            },
        });

        new Swiper('#product-two-slider', {
            lazy: {
                loadPrevNext: true,
            },
            slidesPerView: 5,
            spaceBetween: 20,
            navigation: {
                nextEl: '.prod-two-button-next',
                prevEl: '.prod-two-button-prev',
            },
            loop: true,
            breakpoints: {
                1440: {
                    slidesPerView: 5,
                    spaceBetween: 20
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                375: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0
                }
            },
        });

        new Swiper('#main-slider', {
            lazy: {
                loadPrevNext: true,
            },
            pagination: {
                el: '#main-slider-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.main-slider-button-next',
                prevEl: '.main-slider-button-prev',
            },
            autoplay: 1500,
            autoplayDisableOnInteraction: true,
            speed: 1000,
            loop: true,
            parallax: true,
        });

        new Swiper('#top-slider', {
            lazy: {
                loadPrevNext: true,
            },
            slidesPerView: 3,
            spaceBetween: 8,
            pagination: {
                el: '#top-slider-pagination',
                type: 'bullets',
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 8
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 8,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                375: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            },
        });
    }
}

export default Home
